import { createHistory, History } from 'react-justanother-router';

export const history: History = createHistory();
